import { ArrowRight, Pin } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { PinnedNote } from '@/lib/contacts/types'

export function ProfilePinnedBanner({
  note,
  onOpenTimeline,
}: {
  note: PinnedNote | null | undefined
  onOpenTimeline: () => void
}) {
  if (!note) return null

  return (
    <div className="flex h-9 max-w-2xl items-center gap-2 rounded-md border border-primary/20 bg-primary/5 px-3">
      <Pin className="size-4 shrink-0 text-primary" strokeWidth={1.5} aria-hidden="true" />
      <span className="min-w-0 flex-1 truncate text-body-sm text-foreground">{note.body}</span>
      <span className="whitespace-nowrap text-caption text-muted-foreground">
        — {note.author_name} ·{' '}
        {new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(
          new Date(note.created_at),
        )}
      </span>
      <Button type="button" variant="ghost" size="sm" className="ml-auto" onClick={onOpenTimeline}>
        View on Timeline
        <ArrowRight className="size-3.5" strokeWidth={1.5} aria-hidden="true" />
      </Button>
    </div>
  )
}
